// @flow

import React from 'react';
import pluralizer from 'pluralize';

import { MessageBar } from '@zapier/common-components';

import { type EmailMessages } from '@zapier/team/src/types';

type Props = {
  emailErrors: EmailMessages,
  emailSuccess: EmailMessages,
};

const EmailInviterErrorBlock = (props: Props) => {
  const { emailSuccess, emailErrors } = props;

  if (emailErrors.length === 0) {
    return null;
  }

  const content = emailErrors.map((entry, idx) => (
    <li key={idx}>
      {entry.email}: {entry.message}
    </li>
  ));

  const hasOrHave = emailSuccess.length === 1 ? 'has' : 'have';

  return (
    <MessageBar type="error">
      {`${emailSuccess.length} ${pluralizer(
        'invite',
        emailSuccess.length
      )} ${hasOrHave} sent successfully so far, but ${
        emailErrors.length
      } ${pluralizer('invite', emailErrors.length)} couldn't be sent`}
      <MessageBar.MessageList>{content}</MessageBar.MessageList>
    </MessageBar>
  );
};

export default EmailInviterErrorBlock;
